import {DICT_KEY, getModel, setModel} from "../../../utils/constants";
import SaleOrderService from "../../sale/order/SaleOrderService";
import ModelUtils from "../../../utils/ModelUtils";
import StockStatisticService from "../../stock/statistic/StockStatisticService";

const MODEL_KEY = DICT_KEY.PURCHASE_ORDER;
const storageModel = getModel(MODEL_KEY);

const purchaseOrderModel = {
    state: storageModel ? storageModel : {
        //查询参数
        searchParam: {},
        //单据列表
        documentList: [],
        //销售订单统计信息
        documentStatistic: {},
        //单据列表分页信息
        documentPageInfo: {},
        //选中单据
        selectedDocument: null,
        //选中单据key数组
        selectedDocumentRowKeys: [],
        //单据打印窗口显示
        printDocumentModelVisible: false,


        //单据配件列表
        documentMaterialList: [],
        //选中配件
        selectedDocumentMaterial: null,
        //选中配件key数组
        selectedDocumentMaterialRowKeys: [],


        //添加物料窗口显示
        addMaterialModelVisible: false,
        materialSearchParam: {},
        //待选配件列表
        materialList: [],
        materialPageInfo: {},
        //已选配件列表
        selectedMaterialList: [],

    },
    reducers: {
        setSearchParam(state, payload) {
            state.searchParam = {...state.searchParam, ...payload};
            setModel(MODEL_KEY, {...state});
        },
        setDocumentList(state, payload) {
            state.documentList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setDocumentStatistic(state, payload) {
            state.documentStatistic = payload;
            setModel(MODEL_KEY, {...state});
        },
        setDocumentPageInfo(state, payload) {
            state.documentPageInfo = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedDocument(state, payload) {
            state.selectedDocument = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedDocumentRowKeys(state, payload) {
            state.selectedDocumentRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPrintDocumentModelVisible(state, payload) {
            state.printDocumentModelVisible = payload;
            setModel(MODEL_KEY, {...state});
        },

        setDocumentMaterialList(state, payload) {
            state.documentMaterialList = payload;
            setModel(MODEL_KEY, {...state});
        },
        //添加单据中的配件信息
        addDocumentMaterial(state, payload) {
            state.documentMaterialList.push(...payload);
            setModel(MODEL_KEY, {...state});
        },
        //移除单据中的配件信息
        removeDocumentMaterial(state, payload) {
            state.documentMaterialList = state.documentMaterialList.filter(el => el.id !== payload.id);
            setModel(MODEL_KEY, {...state});
        },
        //设置单据中选中的配件
        setSelectedDocumentMaterial(state, payload) {
            state.selectedDocumentMaterial = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedDocumentMaterialRowKeys(state, payload) {
            state.selectedDocumentMaterialRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },

        setAddMaterialModelVisible(state, payload) {
            state.addMaterialModelVisible = payload;
            setModel(MODEL_KEY, {...state});
        },
        setMaterialSearchParam(state, payload) {
            state.materialSearchParam = payload;
            setModel(MODEL_KEY, {...state});
        },
        //待选配件列表
        setMaterialList(state, payload) {
            state.materialList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setMaterialPageInfo(state, payload) {
            state.materialPageInfo = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedMaterialList(state, payload) {
            state.selectedMaterialList = payload;
            setModel(MODEL_KEY, {...state});
        },
        //添加已选配件
        addSelectedMaterial(state, payload) {
            // console.log(payload);
            // state.materialList = state.materialList.filter(el => el.id !== payload.id);
            state.selectedMaterialList.push(payload);
            setModel(MODEL_KEY, {...state});
        },
        //删除已选配件
        removeSelectedMaterial(state, payload) {
            // state.materialList.push(payload);
            state.selectedMaterialList = state.selectedMaterialList.filter(el => el.id !== payload.id);
            setModel(MODEL_KEY, {...state});
        },
    },
    effects: () => ({
        //加载单据列表
        async loadDocumentList({showMsg = true, duration = 5, data}) {
            const funName = "加载销售订单列表";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.findPage(data);
                const {list, statistic, ...page} = retData;
                list.forEach(el => el.key = el.id);
                this.setDocumentList(list);
                this.setDocumentStatistic(statistic);
                this.setDocumentPageInfo(page);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载单据配件列表
        async loadDocumentMaterialList({showMsg = true, duration = 5, data}) {
            const funName = "加载销售订单配件列表";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.findOne(data);
                if (retData && retData.length > 0) {
                    retData.forEach(el => el.key = el.id);
                }
                this.setDocumentMaterialList(retData);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载查询配件列表
        /*async loadMaterialList({showMsg = true, duration = 5, data}) {
            const funName = "加载配件列表";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await MaterialService.findPage(data);
                const {list, ...page} = retData;
                list.forEach(el => el.key = el.id);
                this.setMaterialList(list);
                this.setMaterialPageInfo(page);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },*/
        //新增订单
        async insert({showMsg = true, duration = 5, data}) {
            const funName = "新增销售订单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.insert(data);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //修改订单
        async update({showMsg = true, duration = 5, data}) {
            const funName = "修改销售订单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.update(data);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //作废
        async disable({showMsg = true, duration = 5, data}) {
            const funName = "销售订单作废";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.cancelOne(data);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //转销售单
        async transfer({showMsg = true, duration = 5, data}) {
            const funName = "销售订单转销售单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleOrderService.transferOne(data);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        //加载库存数据
        async loadStockData({showMsg = false, duration = 5, data = {pageSize: 5}}) {
            let retData = await StockStatisticService.findPage(data);
            const {list, statistic, ...pageInfo} = retData;
            const materialList = list.map(el => ({...el, key: el.id}));
            this.setMaterialList(materialList);
            this.setMaterialPageInfo(pageInfo);

        }
    })
}

export default purchaseOrderModel;